import { use$, useObserve } from '@legendapp/state/react';
import { useRef } from 'react';
import { autoBetState$ } from '../../../state';
import { PredefinedBets } from '../PredefinedBets';

export const AutoBetPredefinedBets = () => {
  const betAmount = use$(autoBetState$.betAmount);
  const lastClickedBetRef = useRef<number | null>(null);
  const internalUpdateRef = useRef(false);

  useObserve(autoBetState$.betAmount, () => {
    if (internalUpdateRef.current) {
      internalUpdateRef.current = false;
      return;
    }
    lastClickedBetRef.current = null;
  });

  const handlePredefinedBetClick = (bet: number) => {
    internalUpdateRef.current = true;

    if (lastClickedBetRef.current === bet) {
      autoBetState$.setBetAmount(betAmount + bet);
    } else {
      autoBetState$.setBetAmount(bet);
      lastClickedBetRef.current = bet;
    }
  };

  return <PredefinedBets onClick={handlePredefinedBetClick} />;
};
